package dev.kuml.portal.web.util

/**
 * Parses the `Retry-After` header on a `429` response. `kuml-portal-server` always sends a plain
 * integer count of seconds, coerced to at least 1 (see `AiRoutes`/`Errors.kt` server-side) -- never
 * an HTTP-date. [parseSeconds] still falls back to [DEFAULT_SECONDS] on a missing/malformed value
 * so the "Generieren" button never looks permanently stuck if a header is ever absent.
 */
public object RetryAfter {
    public const val DEFAULT_SECONDS: Long = 5L

    public fun parseSeconds(headerValue: String?): Long = headerValue?.trim()?.toLongOrNull()?.takeIf { it > 0 } ?: DEFAULT_SECONDS
}
